import { render, staticRenderFns } from "./WordWithPopover.vue?vue&type=template&id=e49bbbd6"
import script from "./WordWithPopover.vue?vue&type=script&lang=js"
export * from "./WordWithPopover.vue?vue&type=script&lang=js"
import style0 from "./WordWithPopover.vue?vue&type=style&index=0&id=e49bbbd6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports